export default "__VITE_ASSET__D58daV6y__"